export default {
	methods: {
		projectStatusName(status){
			switch (status){
				case 0:
					return 'No definido';
				case 1:
					return 'Lead';
				case 2:
					return 'En revisión';
				case 3:
					return 'Pre-aprobado';
				case 4:
					return 'Aprobado';
				case 5:
					return 'En fondeo';
				case 6:
					return 'En firma de contratos';
				case 7:
					return 'En instalación';
				case 8:
					return 'Entregado';
				case 9:
					return 'Rechazado';
				case 10:
					return 'Reembolsado';
				default:
					return 'No definido';
			}
		},
		projecStatusClass(status){
			switch (status){
				case 5:
				case 6:
					return 'status-funding';
				case 7:
					return 'status-running';
				default:
					return 'status-unknown';
			}
		},
		projectStatusColor(status) {
			switch (status){
				case 5:
					return '#f9a01b';
				case 6:
					return '#f68141';
				case 7:
					return '#774e6a';
				default:
					return '#3B3A3E'; // negro
			}
		},
		translateCrowdfundingLoanType(type) {
			const loanTypes = {
				1: "Préstamo Personal"
				, 2: "Préstamo Empresarial"
			};
			return loanTypes[type] || "NA";
		},
		translateLoanType(type) {
			const loanTypes = {
				1: "Ecotecnología"
				, 2: "Eficiencia energética (DEPRECADO)"
				, 3: "Capital de trabajo (DEPRECADO)"
				, 4: "PYME"
				, 5: "Personal"
				, 6: "Movilidad"
				, 7: "Agro"
				, 8: "Hipotecario"
			};
			return `Crédito ${loanTypes[type]}` || "NA";
		},
		translateProductType(type) {
			const productTypes = {
				1: "Crédito Solar (Verde +)"
				, 2: "Crédito Automotriz (Verde +)"
				, 3: "Crédito PYME (Verde +)"
				, 4: "Crédito Personal (Verde +)"
				, 5: "Crédito Solar RedGirasol"
				, 6: "Crédito PYME RedGirasol"
				, 7: "Crédito Personal RedGirasol"
				, 8: "Crédito Automotriz RedGirasol"
				, 9: "Crédito Hipotecario RedGirasol"
			};
			return productTypes[type] || "NA";
		},
		translatePersonalType(type) {
			const personalType = {
				0: "Persona Moral Mexicana"
				, 1: "Persona Física Mexicana"
				, 2: "Persona Física Extranjera"
				, 3: "Persona Moral Extranjera"
			};
			return personalType[type] || "NA";
		},
		translateFinanceCollectionStatus(status)
		{
			let collectionStatusOptions = {
				'preventive'     	:"Preventivo",
				'extrajudicial'  	:"Extrajudicial",
				'judicial'     		:"Judicial",
				'closed'     		:"Cerrado"
			};

			return collectionStatusOptions[status] || "--";
		},
		translateFinanceCollectionSubStatus(status)
		{
			let collectionSubStatusOptions = {
				'credit_regularization' : "Regularización del crédito",
				'credit_settlement' 	: "Liquidación del crédito",
				'credit_restructuring' 	: "Reestructura de crédito",
				'voluntary_surrender' 	: "Entrega voluntaria de las garantías",
				'compulsory_surrender' 	: "Entrega forzosa de las garantías",
				'judicial_agreement_bring_current' : "Convenio judicial puesta al corriente",
				'judicial_agreement_restructuring' : "Convenio judicial reestructura",
				'judicial_agreement_payment_in_kind' : "Convenio judicial dación de pago",
				'judicial_agreement_settlement' : "Convenio judicial liquidación" ,
				'judicial_agreement_installment_settlement' : "Convenio judicial liquidación a plazos"
			};

			return collectionSubStatusOptions[status] || "--";
		},
		translateSyntageStatus(status)
		{
			let syntageStatusOptions = {
				'pending'     	:"Conexión en proceso",
				'valid'  	:"Conexión exitosa",
				'invalid'    	:"Contraseña incorrecta",
				'error'    	:"Conexión fallida"
			};

			return syntageStatusOptions[status] || "--";
		},

		translateContractStatus(status)
		{
			let contractStatusOptions = {
				'generated'     :"Generado",
				'sent'  		:"Enviado a firma",
				'signed'    	:"Firmado",
				'canceled'    	:"Cancelado",
				'verified'    	:"Verificado",
			};

			return contractStatusOptions[status] || "--";
		},
		translateSigningTypeEngine(status)
		{
			let signingTypeEngineOptions = {
				'1'     :"Firma Autógrafa",
				'2'  	:"Firma Electrónica Avanzada (e.firma)",
				'3'  	:"Firma Autógrafa Digital (FAD)",
			};

			return signingTypeEngineOptions[status] || "--";
		},
		translateGender(personal) {
			if(personal.gender != null) {
				const gender = {
					1  	:"HOMBRE",
					2   :"MUJER",
				}
				return gender[personal.gender]||"No definido"
			} else {
				return "--";
			}
		},
		translateBankAccountStatus(status)
        {
            let statusMap = {
                'unverified'            : "SIN VERIFICAR",
                'verified'              : "VERIFICADA",
                'verified_requested'    : "VERIFICACIÓN SOLICITADA",
                'rejected'              : "RECHAZADA",
                'cep_requested'         : "SOLICITUD CEP",
            };

            return statusMap[status]||"--";
        }
	}
}